// extracted by mini-css-extract-plugin
export default {"root":"SocialShare-root","with":"SocialShare-with","copyLink":"SocialShare-copyLink","other":"SocialShare-other","hideOnMobile":"SocialShare-hideOnMobile"};